import {
  Avatar,
  Button,
  Card, CardContent,
  CardHeader,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid, IconButton,
  List, ListItem, ListItemText,
  Paper,
  Typography
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import AttachmentIcon from '@material-ui/icons/Attachment';
import CloseIcon from '@material-ui/icons/Close';
import DialerSipIcon from '@material-ui/icons/DialerSip';
import HearingIcon from '@material-ui/icons/Hearing';
import HistoryIcon from '@material-ui/icons/History';
import PauseIcon from '@material-ui/icons/Pause';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import ScheduleIcon from '@material-ui/icons/Schedule';
import SettingsPhoneIcon from '@material-ui/icons/SettingsPhone';
import SettingsRemoteIcon from '@material-ui/icons/SettingsRemote';
import Timeline from "@material-ui/lab/Timeline";
import TimelineConnector from "@material-ui/lab/TimelineConnector";
import TimelineContent from "@material-ui/lab/TimelineContent";
import TimelineItem from "@material-ui/lab/TimelineItem";
import TimelineOppositeContent from "@material-ui/lab/TimelineOppositeContent";
import TimelineSeparator from "@material-ui/lab/TimelineSeparator";
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import logger from 'src/utils/logger';
import FilesPreview from 'src/components/FilePreview';
import axios from 'src/utils/axios';
import { getUser, openBlob } from 'src/utils/Common';
import UrunTarihce from '../../components/ProductHistoryCenter';
import Tarihce from '../WorkOrder/History';
import Sondaj from '../WorkOrder/Sondaj';
const useStyles = makeStyles((theme) => ({
  root: {},
  chip: {
    margin: theme.spacing(1),
    fontWeight: 'bold', // You can adjust the styling as needed
  },
  chipYellow: {
    backgroundColor: '#FFD700', // Yellow
    color: 'black',
  },
  chipBlue: {
    backgroundColor: '#2196F3', // Blue
    color: 'white',
  },
  chipGreen: {
    backgroundColor: '#00FF00', // Green
    color: 'white',
  },
  chipDarkGreen: {
    backgroundColor: '#006400', // Dark Green
    color: 'white',
  },
  chipRed: {
    backgroundColor: '#FF0000', // Red
    color: 'white',
  },
  CentralRightButton: {
    marginTop: theme.spacing(0),
    width: '100%'
  },
  submitButtonCentral: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  dividerPaper: {
    backgroundColor: '#FF9800'
  },
  valueCentral: {
    fontWeight: theme.typography.fontWeightMedium
  },
  typeCentral: {
    fontWeight: theme.typography.fontWeightMedium
  },
  searchCentral: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIconCentral: {
    marginRight: theme.spacing(2),
    color: theme.palette.icon
  },
  searchInputCentral: {
    flexGrow: 1
  },
  searchButtonCentral: {
    backgroundColor: theme.palette.common.white,
    marginLeft: theme.spacing(2)
  },
  PaperControlTopCentral: {
    marginTop: theme.spacing(1)
  },
}));


function CentralPaperDetail({ className, item, handleCloseDetail }) {




  const classes = useStyles();
  const [urunTarihceAcCentral, seturunTarihceAcCentral] = React.useState(false);
  const [UrunDataCentral, setUrunDataCentral] = React.useState({});
  const [OpenServicePaperHistory, setOpenServicePaperHistory] = React.useState(false);
  const [OpenServicePaperChangeHistory, setOpenServicePaperChangeHistory] = React.useState(false);

  const [FisNo, setFisNo] = React.useState(0);
  const [PaperData, setPaperData] = React.useState([]);
  const [Loadingg, setLoading] = React.useState(false);
  const [tarihce, setTarihce] = React.useState({});
  const [displayDetail, setDisplayDetail] = React.useState(false);
  const [, setDetailData] = React.useState({});
  const [, setUyariTip] = React.useState();
  const [, setUyariAciklama] = React.useState('');
  const [, setUyari] = React.useState(false);
  const [DailerOpen, setDailerOpen] = React.useState(false);
  const [DailerData, setDailerData] = React.useState([]);
  const [DailerDataLink, setDailerDataLink] = React.useState('');
  const [audio, setAudio] = React.useState(new Audio(''));
  const [DailerOpenLink, setDailerOpenLink] = React.useState(false);
  const [CCFilePopupOpen, setCCFilePopupOpen] = React.useState(false);
  const [files, setFiles] = React.useState([]);
  const [ProductChangeHistoryData, setProductChangeHistoryData] = React.useState([]);
  const [SchedulingHistoryData, setSchedulingHistoryData] = React.useState([]);
  const [SchedulePopup, setSchedulePopup] = React.useState(false);
  const fncUrunTarihceAcCentral = () => {
    let jobCentral = {
      UYIL: parseInt(item.UYIL),
      UDONEM: parseInt(item.UDONEM),
      SERINO: parseInt(item.SERINO),
      NITELIK_KODU: parseInt(item.NITELIK_KODU),
      KUL_MODEL_KODU: item.KUL_MODEL_KODU,
    }
    setUrunDataCentral(jobCentral);
    seturunTarihceAcCentral(true);
  }
  const handleCCFileClose = () => {
    setCCFilePopupOpen(false);
  }

  const fncFisTarihceAcCentral = () => {
    setFisNo(item.FIS_NO);
    setOpenServicePaperHistory(true);
  }

  const fncDegisimTarihceAcCentral = () => {
    setFisNo(item.FIS_NO);


    axios.get('/GetArtemisDegisimTarihce/' + item.FIS_NO).then((response) => {
      setProductChangeHistoryData(Array.isArray(response.data) ? response.data : []);
      setOpenServicePaperChangeHistory(true);
    }).catch(error => {
logger.error("Hata detayı:", error.message);
    });



  }

  const getSchedılingHistory = () => {
    const SessionUser = getUser();
    setLoading(true);
    setSchedulePopup(true);
    axios.get('/GetHistoryAppointmentServicePaper/' + item.BIRIM_KODU + '/' + item.BASVURU_NO + '/' + SessionUser.OrganizationUserId).then((response) => {
      setSchedulingHistoryData(response.data);
      setLoading(false);
    }).catch(error => {
      setUyariTip("error");
      setUyariAciklama("Yetkiniz bulunmamaktadır!...");
      setUyari(true);
      setLoading(false);
      logger.error("Hata detayı:", error.message);
    });
  }


  const DialerSipOpen = () => {
    const SessionUser = getUser();
    setLoading(true);
    setDailerOpen(true);
    axios.get('/GetDailerData/' + item.FIS_NO + '/' + SessionUser.OrganizationUserId).then((response) => {
      const PaperCC = response.data;
      setDailerData(PaperCC);
      setLoading(false);
    }).catch(error => {
      setUyariTip("error");
      setUyariAciklama("Yetkiniz bulunmamaktadır!...");
      setUyari(true);
      setLoading(false);
      logger.error("Hata detayı:", error.message);
    });
  }
  React.useEffect(() => {
    setAudio(new Audio(DailerDataLink));
  }, [DailerDataLink]);

  const GetDailerLink = (CallId, KulBirimKodu) => {
    const SessionUser = getUser();
    setLoading(true);
    setDailerOpen(true);
    axios.get('/GetDailerDataLink/' + CallId + '/' + SessionUser.OrganizationUserId + '/' + KulBirimKodu + '/' + SessionUser.UserId).then((response) => {
      const PaperCC = response.data;
      setDailerDataLink(PaperCC);
      setAudio(new Audio(PaperCC));
      setDailerOpenLink(true);
      setLoading(false);
    }).catch(error => {
      setUyariTip("error");
      setUyariAciklama("Yetkiniz bulunmamaktadır!...");
      setUyari(true);
      setLoading(false);
      logger.error("Hata detayı:", error.message);
    });
  }



  const handleCloseDailerLink = () => {
    handlePause();
    setDailerOpenLink(false);
  };

  const handleCloseSondaj = () => {
    setDisplayDetail(false);
  };

  const SondajDurumAc = () => {
    setDetailData({});
    setLoading(true);
    axios.get('/GetArtemisYerindeSondaj/' + item.FIS_NO).then((response) => {
      const PaperCC = response.data;
      setPaperData(PaperCC);
      getTarihce();
    }).catch(error => {
      setUyariTip("error");
      setUyariAciklama("Yetkiniz bulunmamaktadır!...");
      setUyari(true);
      setLoading(false);
      logger.error("Hata detayı:", error.message);
    });

  };
  const getTarihce = () => {

    axios.get('/GetArtemisSondajTarihce/' + item.FIS_NO).then((response) => {
      const PaperCC = response.data;
      setTarihce(PaperCC);
      setLoading(false);
      setDisplayDetail(true);
    }).catch(error => {
logger.error("Hata detayı:", error.message);
    });

  };
  const handleCloseDailer = () => {
    setDailerOpen(false);
  };
  const handleRefreshSondaj = () => {
    setDisplayDetail(false);
    SondajDurumAc();


  };
  const handleCloseServicePaperHistory = () => {
    setOpenServicePaperHistory(false);
  };

  const handleCloseServicePaperChangeHistory = () => {
    setOpenServicePaperChangeHistory(false);
  };

  const handlePlay = () => {
    if (audio) {
      const playPromise = audio.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            // Ses başarıyla oynatılıyor
          })
          .catch(error => {
            logger.warn("Ses oynatma hatası:", error.message);
          });
      }
    }
  };


  const setFileOpen = () => {
    axios.get('/GetArtemisDosyaListe/' + item.FIS_NO).then((response) => {
      if (response.data === "") {
        setLoading(false);
        setFiles([]);
      } else {
        const Deger = response.data;
        setFiles(Deger);
        setLoading(false);

      }
      setCCFilePopupOpen(true);
    }).catch(error => {
      setFiles([]);
      setLoading(false);
      setCCFilePopupOpen(true);
      logger.error("Hata detayı:", error.message);
    });

  }

  const handlePause = () => {
    audio.pause();
  };


  const getColorClass = (status) => {
    switch (status) {
      case 'Bekliyor':
        return classes.chipYellow;
      case 'Yola Çıkıldı':
        return classes.chipBlue;
      case 'Başlandı':
        return classes.chipGreen;
      case 'Tamamlandı':
        return classes.chipDarkGreen;
      default:
        return classes.chipRed;
    }
  };



  const ArtemisPaperDetailCreate = () => {
    var Uyari = item.FIS_NO + " fiş numaralı müşterimize ait yeni bir fiş oluşturulacaktır. Devam etmek istediğinizdne eminmisiniz?";
    confirmAlert({
      message: Uyari,
      buttons: [
        {
          label: 'Evet',
          onClick: () => SetArtemisPaperDetailCreate(item.FIS_NO)
        },
        {
          label: 'Hayır',
          onClick: () => { return; }
        }
      ]
    });
  }

  const SetArtemisPaperDetailCreate = (FisNo) => {
    const SessionUser = getUser();
    axios.get('/SetArtemisPaperDetailCreate/' + SessionUser.ServiceShopId + '/' + SessionUser.TechnicianId + '/' + FisNo).then(() => {
      setLoading(false);
    }).catch(() => {
      setLoading(false);
    });

  }







  const handleIOTClickOpen = (AtananIs) => {
    var Uyari = AtananIs.FIS_NO + " fiş numaralı müşterimizin " + AtananIs.KUL_MODEL_KODU + ' ' + AtananIs.MODEL + ' Ürününe uzaktan bağlanılıp sağlık verilerine ulaşılacaktır. Devam etmek istediğinizdne eminmisiniz?';
    confirmAlert({
      message: Uyari,
      buttons: [
        {
          label: 'Evet',
          onClick: () => handleIOTClick(AtananIs)
        },
        {
          label: 'Hayır',
          onClick: () => { return; }
        }
      ]
    });
  }





  const handleIOTClick = (AtananIs) => {
    setLoading(true);
    if (AtananIs.SERINO.toString().substring(0, 1).toString() === '9') {
      AtananIs.SERINO = "1" + AtananIs.SERINO.toString().substring(1, AtananIs.SERINO.toString().length);
    }

    var Barkod = AtananIs.KUL_MODEL_KODU
      + AtananIs.UYIL.toString().substring(2, 4).toString()
      + AtananIs.SERINO.toString().padStart(6, '0')
      + AtananIs.UDONEM.toString().padStart(2, '0') + '01';
    const configIOT = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    axios.get('/FileImportExport/ArtemisIOT/' + Barkod + '/' + AtananIs.FIS_NO, configIOT)
      .then(response => {
        if (response.data.type === 'text/plain') {
          alert("Uzaktan Cihaza Ulaşılamadı. Lütfen daha sonra tekrar deneyiniz!...");
        } else {
          openBlob(response.data, Barkod);
        }
        setLoading(false);
      }).catch(() => {
        setLoading(false);
        alert("Uzaktan Cihaza Ulaşılamadı. Lütfen daha sonra tekrar deneyiniz!...");
      });

  }

  return (
    <div>
      <Card className={clsx(classes.root, className)}>
        <CardContent className={classes.contentCentral}>
          <div className={classes.innerCentral}>
            {Loadingg ? (
              <CircularProgress
                status={'loading'}
                style={{ marginLeft: '40%' }}
              />
            ) : (
              <Grid container spacing={1}>
                <Grid item xs={2} sm={2}>
                  <IconButton
                    color="primary"
                    onClick={() => handleCloseDetail()}
                    alignItems="left"
                    size="small">
                    <ArrowBackIcon />
                  </IconButton>
                </Grid>

                {/* AKSİYON BUTONLARI */}
                <Grid item xs={12} sm={12}>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={ArtemisPaperDetailCreate}
                    className={classes.CentralRightButton}
                    endIcon={<AddIcon>Gönder</AddIcon>}
                  >
                    Yenİ Fİş Oluştur
                  </Button>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={fncFisTarihceAcCentral}
                    className={classes.CentralRightButton}
                    endIcon={<HistoryIcon>Gönder</HistoryIcon>}
                  >
                    Fİşİn Durum Tarİhçesİ
                  </Button>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={fncDegisimTarihceAcCentral}
                    className={classes.CentralRightButton}
                    endIcon={<HistoryIcon>Gönder</HistoryIcon>}
                  >
                    Değİşİmİn Durum Tarİhçesİ
                  </Button>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={SondajDurumAc}
                    className={classes.CentralRightButton}
                    endIcon={<SettingsPhoneIcon>Gönder</SettingsPhoneIcon>}
                  >
                    Sondaj Durum
                  </Button>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={DialerSipOpen}
                    className={classes.CentralRightButton}
                    endIcon={<DialerSipIcon>Open</DialerSipIcon>}
                  >
                    Görüşmeler
                  </Button>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={setFileOpen}
                    className={classes.CentralRightButton}
                    endIcon={<AttachmentIcon>Open</AttachmentIcon>}
                  >
                    Dosya
                  </Button>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={getSchedılingHistory}
                    className={classes.CentralRightButton}
                    endIcon={<ScheduleIcon>Open</ScheduleIcon>}>
                    Randevu Tarİhçe
                  </Button>
                </Grid>
                <Grid item xs={12} sm={12}>
                  {parseInt(item.HOMEWHIZ) !== 0 ? (
                    Loadingg ? (
                      <CircularProgress
                        status={'loading'}
                        style={{ marginLeft: '50%' }}
                      />
                    ) : (
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => handleIOTClickOpen(item)}
                        className={classes.CentralRightButton}
                        endIcon={<SettingsRemoteIcon>Open</SettingsRemoteIcon>}>
                        Uzaktan Bağlantı
                      </Button>
                    )
                  ) : ''}
                </Grid>

                {/* GENEL BİLGİLER */}
                <Grid item xs={12} sm={12} className={classes.PaperControlTopCentral} >
                  <Typography variant="caption" display="block">
                    <b>FişNo</b>
                  </Typography>
                  <Typography variant="subtitle2">
                    {item.FIS_NO}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Divider style={{ backgroundColor: '#FF9800' }} />
                </Grid>
                <Grid item xs={6} sm={6}>
                  <Typography variant="caption" display="block" >
                    <b>ÇağrıTarih</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.CAGRI_TARIHI}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={6}>
                  <Typography variant="caption" display="block" >
                    <b>İşlemTarih</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.ISLEM_TARIHI}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Divider style={{ backgroundColor: '#FF9800' }} />
                </Grid>
                {/* UDS ALANLARI (YENİ EKLENENLER) */}
                <Grid item xs={12} sm={12}>
                  <Typography variant="overline" style={{ color: '#FF9800', fontWeight: 'bold' }}>Ürün Değişim Bilgileri</Typography>
                </Grid>
                <Grid item xs={6} sm={6}>
                  <Typography variant="caption" display="block"><b>Talep Model</b></Typography>
                  <Typography variant="subtitle2">{item.UDS_TALEP_EDILEN_KUL_MODEL_KODU || "-"}</Typography>
                </Grid>
                <Grid item xs={6} sm={6}>
                  <Typography variant="caption" display="block"><b>Verilen Model</b></Typography>
                  <Typography variant="subtitle2">{item.UDS_VERILENSTOKNO || "-"}</Typography>
                </Grid>
                <Grid item xs={6} sm={6}>
                  <Typography variant="caption" display="block"><b>Uds Durum</b></Typography>
                  <Typography variant="subtitle2">{item.UDS_DURUM || "-"}</Typography>
                </Grid>
                <Grid item xs={6} sm={6}>
                  <Typography variant="caption" display="block"><b>Uds Neden</b></Typography>
                  <Typography variant="subtitle2">{item.UDS_NEDEN || "-"}</Typography>
                </Grid>
                <Grid item xs={6} sm={6}>
                  <Typography variant="caption" display="block"><b>Teminsiz Stok</b></Typography>
                  <Typography variant="subtitle2">{item.UDS_TEMINSIZ_STOK_KUL_KODU || "-"} / {item.UDS_TEMINSIZ_STOK}</Typography>
                </Grid>
                <Grid item xs={6} sm={6}>
                  <Typography variant="caption" display="block"><b>Ürün Teslim Durumu</b></Typography>
                  <Typography variant="subtitle2" style={{ color: item.UDS_SERVIS_URUNU_TESLIM_ALDI ? 'green' : 'red' }}>
                    {item.UDS_SERVIS_URUNU_TESLIM_ALDI ? "Teslim Alındı" : "Teslim Alınmadı"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Typography variant="caption" display="block"><b>Servis UDS Notu</b></Typography>
                  <Typography variant="subtitle2" style={{ fontStyle: 'italic' }}>{item.UDS_SERVIS_NOTU || "-"}</Typography>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Divider style={{ backgroundColor: '#FF9800' }} />
                </Grid>

                {/* DİĞER MEVCUT ALANLAR */}
                <Grid item xs={4} sm={4}>
                  <Typography variant="caption" display="block" >
                    <b>Bölge</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.BOLGE}
                  </Typography>
                </Grid>
                <Grid item xs={4} sm={4}>
                  <Typography variant="caption" display="block" >
                    <b>Servis</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.SERVIS_KODU} {item.SERVIS}
                  </Typography>
                </Grid>
                <Grid item xs={4} sm={4}>
                  <Typography variant="caption" display="block" >
                    <b>Teknisyen</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.KUL_TEK_KODU} {item.TEKNISYEN}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Divider style={{ backgroundColor: '#FF9800' }} />
                </Grid>
                <Grid item xs={6} sm={6}>
                  <Typography variant="caption" display="block" >
                    <b>BaşvuruNedeni</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.BASVURU_NEDENI}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={6}>
                  <Typography variant="caption" display="block" >
                    <b>Randevu</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.RANDEVU_TARIHI}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Divider style={{ backgroundColor: '#FF9800' }} />
                </Grid>
                <Grid item xs={6} sm={6}>
                  <Typography variant="caption" display="block" >
                    <b>Durum</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.DURUM}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={6}>
                  <Typography variant="caption" display="block" >
                    <b>Sorumlu</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.SORUMLU}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Divider style={{ backgroundColor: '#FF9800' }} />
                </Grid>
                <Grid item xs={4} sm={4}>
                  <Typography variant="caption" display="block" >
                    <b>GarantiTarih</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.GARANTI_TARIHI}
                  </Typography>
                </Grid>
                <Grid item xs={4} sm={4}>
                  <Typography variant="caption" display="block" >
                    <b>GarantiBitis</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.GARANTI_BITIS_TARIHI}
                  </Typography>
                </Grid>
                <Grid item xs={4} sm={4}>
                  <Typography variant="caption" display="block" >
                    <b>GarantiTip</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.GARANTI_TIPI}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Divider style={{ backgroundColor: '#FF9800' }} />
                </Grid>
                <Grid item xs={3} sm={3}>
                  <Typography variant="caption" display="block" >
                    <b>GarantiBas</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.GARANTI_BASLANGIC_TG}
                  </Typography>
                </Grid>
                <Grid item xs={3} sm={3}>
                  <Typography variant="caption" display="block" >
                    <b>EkGarantiYıl</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.EK_GARANTI_YIL}
                  </Typography>
                </Grid>
                <Grid item xs={3} sm={3}>
                  <Typography variant="caption" display="block" >
                    <b>EkGarantiBas</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.EK_GARANTI_BASLANGIC_TG}
                  </Typography>
                </Grid>
                <Grid item xs={3} sm={3}>
                  <Typography variant="caption" display="block" >
                    <b>GarantiBit</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.GARANTI_BITIS_TG}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Divider style={{ backgroundColor: '#FF9800' }} />
                </Grid>
                <Grid item xs={3} sm={3}>
                  <Typography variant="caption" display="block" >
                    <b>ModelKodu</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.KUL_MODEL_KODU}
                  </Typography>
                </Grid>
                <Grid item xs={9} sm={9}>
                  <Typography variant="caption" display="block" >
                    <b>Model</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.MODEL}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Divider style={{ backgroundColor: '#FF9800' }} />
                </Grid>
                <Grid item xs={3} sm={3}>
                  <Typography variant="caption" display="block" >
                    <b>Marka</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.MARKA}
                  </Typography>
                </Grid>
                <Grid item xs={3} sm={3}>
                  <Typography variant="caption" display="block" >
                    <b>Uyıl</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.UYIL}
                  </Typography>
                </Grid>
                <Grid item xs={3} sm={3}>
                  <Typography variant="caption" display="block" >
                    <b>Udonem</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.UDONEM}
                  </Typography>
                </Grid>
                <Grid item xs={3} sm={3}>
                  <Typography variant="caption" display="block" >
                    <b>SeriNo</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.SERINO}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Divider style={{ backgroundColor: '#FF9800' }} />
                </Grid>
                <Grid item xs={4} sm={4}>
                  <Typography variant="caption" display="block" >
                    <b>Adı</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.ADI}
                  </Typography>
                </Grid>
                <Grid item xs={4} sm={4}>
                  <Typography variant="caption" display="block" >
                    <b>Soyadı</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.SOYADI}
                  </Typography>
                </Grid>
                <Grid item xs={4} sm={4}>
                  <Typography variant="caption" display="block" >
                    <b>Telefon</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.TEL1} {item.TEL2}
                  </Typography>
                </Grid>
                <Grid item xs={4} sm={4}>
                  <Typography variant="caption" display="block" >
                    <b>İl</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.IL}
                  </Typography>
                </Grid>
                <Grid item xs={4} sm={4}>
                  <Typography variant="caption" display="block" >
                    <b>İlçe</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.ILCE}
                  </Typography>
                </Grid>
                <Grid item xs={4} sm={4}>
                  <Typography variant="caption" display="block" >
                    <b>Mahalle</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.MAHALLE}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Typography variant="caption" display="block" >
                    <b>Adres</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.ADRES}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Divider style={{ backgroundColor: '#FF9800' }} />
                </Grid>
                <Grid item xs={12} sm={12} className={classes.PaperControlTopCentral} >
                  <Typography variant="caption" display="block">
                    <b>Başvuru Notu</b>
                  </Typography>
                  <Typography variant="subtitle2">
                    {item.BASVURU_NOTU}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12} className={classes.PaperControlTopCentral} >
                  <Typography variant="caption" display="block">
                    <b>Çağrı Merkezi Notu</b>
                  </Typography>
                  <Typography variant="subtitle2">
                    {item.CAGRI_MERKEZI_NOTU}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12} className={classes.PaperControlTopCentral} >
                  <Typography variant="caption" display="block">
                    <b>Sonuç Notu</b>
                  </Typography>
                  <Typography variant="subtitle2">
                    {item.SONUC_NOTU}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Divider style={{ backgroundColor: '#FF9800' }} />
                </Grid>
                <Grid item xs={4} sm={4}>
                  <Typography variant="caption" display="block" >
                    <b>İşçilikToplam</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.ISCILIK_TOPLAMI?.toFixed(2) + "₺"}
                  </Typography>
                </Grid>
                <Grid item xs={4} sm={4}>
                  <Typography variant="caption" display="block" >
                    <b>MalzemeToplam</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.MALZEME_TOPLAMI?.toFixed(2) + "₺"}
                  </Typography>
                </Grid>
                <Grid item xs={4} sm={4}>
                  <Typography variant="caption" display="block" >
                    <b>YanOdemeToplam</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.YAN_ODEME_TUTARI?.toFixed(2) + "₺"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Divider style={{ backgroundColor: '#FF9800' }} />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Typography variant="caption" display="block" >
                    <b>Hizmetler</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.HIZMETLER && item.HIZMETLER.split(',').map((hizmet, index) => (
                      <span key={index}>
                        <b>{index + 1})</b>  {hizmet.trim()}
                        <br />
                      </span>
                    ))}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Divider style={{ backgroundColor: '#FF9800' }} />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Typography variant="caption" display="block" >
                    <b>İşçilikler</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.ISCILIKLER === undefined ? "" : JSON.parse(item.ISCILIKLER).map((iscilik, idx) =>
                      iscilik.KUL_ISCILIK_KODU.length > 1 ?
                        <Grid container key={idx} xs={12} sm={12}>
                          <Grid item xs={4} sm={4}>
                            <Typography variant="subtitle2" >
                              {iscilik.KUL_ISCILIK_KODU}
                            </Typography>
                          </Grid>
                          <Grid item xs={5} sm={5}>
                            <Typography variant="subtitle2" >
                              {iscilik.ISCILIK}
                            </Typography>
                          </Grid>
                          <Grid item xs={3} sm={3}>
                            <Typography variant="subtitle2" >
                              <b>{iscilik.FIYAT.toFixed(2) + "₺"}</b>
                            </Typography>
                          </Grid>
                          <Grid item xs={12} sm={12}>
                            <Divider style={{ backgroundColor: '#424242' }} />
                          </Grid>
                        </Grid>
                        : ""
                    )}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Divider style={{ backgroundColor: '#FF9800' }} />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Typography variant="caption" display="block" >
                    <b>Malzemeler</b>
                  </Typography>
                </Grid>
                {item.MALZEMELER === undefined ? "" : JSON.parse(item.MALZEMELER).map((malzeme, idx) =>
                  malzeme.Stok.length > 2 ?
                    <Grid container key={idx} xs={12} sm={12}>
                      <Grid item xs={4} sm={4}>
                        <Typography variant="subtitle2" >
                          {malzeme.Stok}
                        </Typography>
                      </Grid>
                      <Grid item xs={8} sm={8}>
                        <Typography variant="subtitle2" >
                          {malzeme.Malzeme}
                        </Typography>
                      </Grid>
                      <Grid item xs={4} sm={4}>
                        <Typography variant="subtitle2" >
                          <b>{malzeme.Adet + ' Adet'} </b>
                        </Typography>
                      </Grid>
                      <Grid item xs={8} sm={8}>
                        <Typography variant="subtitle2" >
                          <b>{malzeme.FIYAT.toFixed(2) + "₺"}</b>
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <Divider style={{ backgroundColor: '#424242' }} />
                      </Grid>
                    </Grid>
                    : ""
                )}
                <br />
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={fncUrunTarihceAcCentral}
                    className={classes.submitButtonCentral}
                    endIcon={<HistoryIcon>Gönder</HistoryIcon>}
                  >
                    Ürüne Verİlmİş Hİzmetler
                  </Button>
                </Grid>
              </Grid>
            )}
          </div>
          <Divider />
          {
            (urunTarihceAcCentral)
              ? <UrunTarihce UrunData={UrunDataCentral}></UrunTarihce>
              : <div></div>
          }
        </CardContent>
      </Card>
      <Dialog
        fullScreen={true}
        open={OpenServicePaperHistory}
        onClose={handleCloseServicePaperHistory}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          Fişin Durum Tarihçesi
        </DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <Tarihce FisNo={FisNo} readonly={true} />
          </DialogContentText>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            endIcon={<CloseIcon>Close</CloseIcon>}
            onClick={handleCloseServicePaperHistory}>
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullScreen={true}
        open={OpenServicePaperChangeHistory}
        onClose={handleCloseServicePaperChangeHistory}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          Değişim Durum Tarihçesi
        </DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <Card>
              <CardHeader title={"Değişim Tarihçe"} />

              <Divider />
              {/* {
            taskHistoryReducer.loading ?
              <CircularProgress
                status={'loading'}
                style={{ marginLeft: '50%' }}
              />
              : <div></div>
          } */}
              <CardContent className={classes.content}>
                <Timeline align="alternate">
                  {ProductChangeHistoryData.map((log, index) => (
                    <TimelineItem>
                      <TimelineOppositeContent>
                        <Typography variant="body2" color="textSecondary" style={{ paddingTop: 10 }}>
                          {log.GUN + '.' + log.AY.substring(0, 3) + '.' + log.YIL + ' ' + log.SAAT}
                        </Typography>
                      </TimelineOppositeContent>
                      <TimelineSeparator>
                        <Avatar style={{ backgroundColor: '#424242', color: '#FF9800' }}>{ProductChangeHistoryData?.length - index}</Avatar>
                        <TimelineConnector />
                      </TimelineSeparator>
                      <TimelineContent>
                        <Paper elevation={1} className={classes.paper} align="left">
                          <Typography variant="h6" gutterBottom>
                            {log.DURUM}
                          </Typography>
                          <Divider />
                          <Typography variant="body2">
                            <b>Başvuru Notu:</b>{log.BASVURU_NOTU}<br />
                            <b>Sonuc Notu:</b>{log.SONUC_NOTU}<br />
                            <b>Kullanıcı:</b>{log.ISLEM_YAPAN}:{log.KULLANICI}<br />
                          </Typography>
                        </Paper>
                      </TimelineContent>
                    </TimelineItem>
                  ))}
                </Timeline>
              </CardContent>

            </Card>

          </DialogContentText>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            endIcon={<CloseIcon>Close</CloseIcon>}
            onClick={handleCloseServicePaperChangeHistory}>
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullScreen={true}
        open={displayDetail}
        onClose={handleCloseSondaj}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          Sondaj Durum
        </DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <Sondaj items={PaperData}
              tarihce={tarihce}
              Loading={Loadingg}
              className={classes.CentralPaperControl}
              handleCloseSondaj={handleCloseSondaj}
              handleRefreshSondaj={handleRefreshSondaj} />
          </DialogContentText>
        </DialogContent>
        <Divider />
        <DialogActions>



          <Button
            variant="contained"
            color="secondary"
            endIcon={<CloseIcon>Close</CloseIcon>}
            onClick={handleCloseSondaj}>
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullScreen={true}
        open={DailerOpen}
        onClose={handleCloseDailer}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          Görüşmeler
        </DialogTitle>
        <Divider />
        <DialogContent>
          <List className={classes.root}>
            {DailerData.map(log => (
              <div key={log.FisNo}>
                <ListItem alignItems="flex-start">
                  <ListItemText>
                    <Typography variant="body1" gutterBottom>
                      <b>Arama Tarihi : </b>
                      {log.ARAMA_TARIHI}
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      <b>Durum : </b>
                      {log.SONUC}
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      <b>Bekleme Süre(Sn) : </b>
                      {log.BEKLEME}
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      <b>Konuşma Süre(Sn) : </b>
                      {log.KONUSMA_SURESI}
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      <b>Tip : </b>
                      {log.ARAYAN}
                    </Typography>
                    <Typography variant="body1" gutterBottom className={classes.fields}>
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => GetDailerLink(log.CALL_ID, log.KUL_BIRIM_KODU)}
                        className={classes.submitButton}
                        endIcon={<HearingIcon>Gonder</HearingIcon>}
                      >

                        {"Dİnle"}
                      </Button>
                    </Typography>
                  </ListItemText>
                </ListItem>
                <Divider className={classes.divider} />
              </div>
            ))}
          </List>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            endIcon={<CloseIcon>Close</CloseIcon>}
            onClick={handleCloseDailer}>
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={DailerOpenLink}
        onClose={handleCloseDailerLink}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <Button
            variant="contained"
            color="secondary"
            fullWidth
            endIcon={<PlayArrowIcon>Close</PlayArrowIcon>}
            onClick={handlePlay}>
            Başlat
          </Button>
          <br />
          <br />
          <Button
            variant="contained"
            color="secondary"
            fullWidth
            endIcon={<PauseIcon>Close</PauseIcon>}
            onClick={handlePause}>
            Durdur
          </Button>
          <br />
          <br />
          <Button
            variant="contained"
            color="secondary"
            fullWidth
            endIcon={<CloseIcon>Close</CloseIcon>}
            onClick={handleCloseDailerLink}>
            Kapat
          </Button>

        </DialogContent>

      </Dialog>
      <Dialog
        open={CCFilePopupOpen}
        fullScreen={true}
        onClose={handleCCFileClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <FilesPreview FisNo={item.FIS_NO} files={files} setLoading={setLoading} />
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            endIcon={<CloseIcon>Close</CloseIcon>}
            onClick={handleCCFileClose}>
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullScreen={true}
        open={SchedulePopup}
        onClose={() => setSchedulePopup(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          Randevu Tarihçe
        </DialogTitle>
        <Divider />
        <DialogContent>
          <List className={classes.root}>
            {SchedulingHistoryData?.map(log => (
              <Card key={log.ID}>
                <CardContent>
                  <Grid container spacing={1}>
                    <Grid item xs={4} sm={4}>
                      <Typography variant='h6' gutterBottom>Randevu:</Typography>
                    </Grid>
                    <Grid item xs={8} sm={8}>
                      <Typography variant='subtitle2' gutterBottom>{log.RANDEVU_TARIHI + ' ' + log.TIME_SLOT}</Typography>
                    </Grid>
                    <Grid item xs={4} sm={4}>
                      <Typography variant='h6' gutterBottom>Teknisyen:</Typography>
                    </Grid>
                    <Grid item xs={8} sm={8}>
                      <Typography variant='subtitle2' gutterBottom>{log.KUL_TEK_KODU + ' ' + log.ADI + ' ' + log.SOYADI}</Typography>
                    </Grid>
                    <Grid item xs={4} sm={4}>
                      <Typography variant='h6' gutterBottom>İşlem Tarihi:</Typography>
                    </Grid>
                    <Grid item xs={8} sm={8}>
                      <Typography variant='subtitle2' gutterBottom>{log.TARIH}</Typography>
                    </Grid>
                    <Grid item xs={4} sm={4}>
                      <Typography variant='h6' gutterBottom>Durum:</Typography>
                    </Grid>
                    <Grid item xs={8} sm={8} color="warning">
                      <Typography variant='subtitle2' gutterBottom>
                        <Chip
                          label={log.RANDEVU_DURUM}
                          variant="outlined"
                          className={`${classes.chip} ${getColorClass(log.RANDEVU_DURUM)}`}
                        />
                      </Typography>
                    </Grid>
                  </Grid>
                </CardContent>

                {/* <Divider className={classes.divider} /> */}
              </Card>
            ))}
          </List>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            endIcon={<CloseIcon>Close</CloseIcon>}
            onClick={() => setSchedulePopup(false)}>
            Kapat
          </Button>
        </DialogActions>
      </Dialog>

    </div >
  );
}

CentralPaperDetail.propTypes = {
  className: PropTypes.string
};

export default CentralPaperDetail;
